import { toRelativeUrl } from "@okta/okta-auth-js";
import { useOktaAuth } from "@okta/okta-react";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { Spinner } from "./ui";

export function RequiresAuth() {
  const { oktaAuth, authState } = useOktaAuth();

  useEffect(() => {
    if (authState && !authState.isAuthenticated) {
      oktaAuth.setOriginalUri(
        toRelativeUrl(window.location.href, window.location.origin),
      );
      oktaAuth.signInWithRedirect();
    }
  }, [oktaAuth, authState]);

  if (!authState?.isAuthenticated) return <Spinner />;
  return <Outlet />;
}
